import {UPDATE_MAGAZINE_START} from "../../types";

export const update_magazine = (payload) => ({
    type: UPDATE_MAGAZINE_START,
    payload,
});
